/**
 * @module oauth/userRequest
 *
 * @fileOverview Exports an Axios instance to be used for requests that need
 * the scope `customer`.
 */

import axios from 'axios'

import { apiUrl, requestTimeout } from '@/data/appConfig'

import {
  errorLoggerInterceptor,
  sessionInterceptor,
  unauthorizedInterceptor,
} from './interceptors'

/** @type {AxiosInstance} */
const userRequestInstance = axios.create({
  baseURL: apiUrl,
  timeout: requestTimeout,
})

/** Request Interceptors */
userRequestInstance.interceptors.request.use(sessionInterceptor, error =>
  Promise.reject(error),
)

/** Response Interceptors */
userRequestInstance.interceptors.response.use(
  async responseConfig => Promise.resolve(responseConfig),
  errorLoggerInterceptor,
)
userRequestInstance.interceptors.response.use(
  async responseConfig => Promise.resolve(responseConfig),
  unauthorizedInterceptor,
)

export default userRequestInstance
